/**
 * 避難先ナレッジの同梱データ読み込み。
 *
 * - knowledge-seeds.json … 初期シード (生成元: docs/evacuation_sites の運用記録を手動正規化。
 *   エリア別正解パターン p-*, 修正事例 c-*)。Firestore モードでは ensureSeedsKnowledge が
 *   これを投入し、以後はアプリでの出典つき保存が同じコレクションに蓄積される。
 * - municipal-rules.json … 自治体ごとの制度差 (R8)。変化が稀な「理論」データなので同梱。
 */
import seedsJson from '@/data/knowledge-seeds.json';
import municipalRulesJson from '@/data/municipal-rules.json';
import type { KnowledgeRecord, MunicipalRule } from '@/types/knowledge';

export const KNOWLEDGE_SEEDS = seedsJson as unknown as KnowledgeRecord[];

export const MUNICIPAL_RULES = municipalRulesJson as unknown as MunicipalRule[];

/**
 * シードのディープコピー (imported module を書き換えないため)。
 * シード JSON は updatedAt を持たないため recordedAt から補完する
 * (crud の型制約 { id, updatedAt } を満たすのはここ1箇所に閉じる)。
 */
export function cloneKnowledgeSeeds(): KnowledgeRecord[] {
  return KNOWLEDGE_SEEDS.map((r) => {
    const copy = JSON.parse(JSON.stringify(r)) as KnowledgeRecord;
    copy.updatedAt = copy.updatedAt ?? copy.recordedAt;
    return copy;
  });
}
